import React, { useState } from 'react';
import api from './api';

// Пропсы uid и token приходят из App.js
function ResetPasswordConfirmPage({ uid, token }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post('password-reset-confirm/', { uid, token, password });
      setSuccess(true);
      
      // Вместо navigate('/') делаем перенаправление на главную через 2.5 сек
      setTimeout(() => {
        window.location.href = '/';
      }, 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Ссылка устарела или недействительна.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#090d16] flex items-center justify-center p-4 text-white">
      <div className="max-w-md w-full bg-[#111827] border border-gray-800 rounded-2xl p-6 shadow-2xl space-y-4">
        <div>
          <h2 className="text-2xl font-bold">Установка нового пароля</h2>
          <p className="text-gray-400 text-xs mt-1">Придумайте надежный пароль для вашего аккаунта</p>
        </div>

        {success ? (
          <div className="p-4 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 rounded-xl text-sm text-center font-medium">
            Пароль успешно изменён! Перенаправляем на форму входа...
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="p-3 bg-rose-500/10 border border-rose-500/20 text-rose-400 rounded-xl text-xs font-medium">
                {error}
              </div>
            )}
            <div>
              <label className="block text-xs uppercase font-bold text-gray-400 mb-1">Новый пароль</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#1f2937]/50 border border-gray-700 rounded-xl py-2 px-3 text-sm text-white outline-none focus:border-indigo-500 transition"
                placeholder="••••••••"
              />
            </div>
            <div>
              <label className="block text-xs uppercase font-bold text-gray-400 mb-1">Повторите новый пароль</label>
              <input
                type="password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full bg-[#1f2937]/50 border border-gray-700 rounded-xl py-2 px-3 text-sm text-white outline-none focus:border-indigo-500 transition"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 rounded-xl font-bold text-sm transition cursor-pointer shadow-lg shadow-indigo-600/20"
            >
              {loading ? 'Сохранение...' : 'Сохранить новый пароль'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordConfirmPage;